import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  makeStyles
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import confetti from "canvas-confetti";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "100%",
    },
  },
}));

const RevenueModal = ({ open, onClose, onSave, ticketId }) => {
  const classes = useStyles();
  const [value, setValue] = useState("");
  const [periodicity, setPeriodicity] = useState("");

  const handleSave = () => {
    if (!value) return;
    
    onSave({ revenueValue: value, revenuePeriodicity: periodicity });
    
    // Efeito de confetes e parabéns
    confetti({
      particleCount: 150,
      spread: 70,
      origin: { y: 0.6 },
      zIndex: 2000
    });
    
    toast.success("Parabéns pela venda! 🚀💰", {
      position: "top-center",
      autoClose: 5000,
    });

    setValue("");
    setPeriodicity("");
  };

  const handleClose = () => {
    setValue("");
    setPeriodicity("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Registrar Receita - Ticket #{ticketId}</DialogTitle>
      <DialogContent className={classes.root}>
        <NumberFormat
          label="Valor da Receita"
          value={value}
          customInput={TextField}
          variant="outlined"
          onValueChange={(values) => {
            const { value } = values;
            setValue(value);
          }}
          thousandSeparator="."
          decimalSeparator=","
          prefix="R$ "
          allowNegative={false}
          fullWidth
          required
          margin="dense"
        />
        <TextField
          label="Periodicidade"
          variant="outlined"
          select
          value={periodicity}
          onChange={(e) => setPeriodicity(e.target.value)}
          fullWidth
          margin="dense"
        >
          <MenuItem value="">Nenhuma</MenuItem>
          <MenuItem value="unica">Única vez</MenuItem>
          <MenuItem value="mensal">Mensal</MenuItem>
          <MenuItem value="trimestral">Trimestral</MenuItem>
          <MenuItem value="semestral">Semestral</MenuItem>
          <MenuItem value="anual">Anual</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={!value}
        >
          Confirmar e Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RevenueModal;
